 
 
export function isModalRoute(path) {
  return (this.call('findModal', path) || {}).FoundModal
}
